var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"return-button btn btn-perfcell",on:{"click":_vm.handleClick}},[_c('span',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t("return")))])])}
var staticRenderFns = []

export { render, staticRenderFns }